var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5C0 3.89543 0.89543 3 2 3H9.5C10.5158 3 11.3548 3.75732 11.483 4.73817L14.5939 3.35557C15.2551 3.06166 16 3.54572 16 4.26938V11.7306C16 12.4543 15.2551 12.9383 14.5939 12.6444L11.483 11.2618C11.3548 12.2427 10.5158 13 9.5 13H2C0.89543 13 0 12.1046 0 11V5ZM11.5 10.1751L15 11.7306L15 4.26938L11.5 5.82494V10.1751ZM2 4C1.44772 4 1 4.44772 1 5V11C1 11.5523 1.44772 12 2 12H9.5C10.0523 12 10.5 11.5523 10.5 11V5C10.5 4.44772 10.0523 4 9.5 4H2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.0373e1ab40eb0156d14ff25f1faf4b52.svg";
export { ForwardRef as ReactComponent };